<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <h2 class="dark--text font-weight-bold">Set Menu Report Master</h2>
      </v-flex>

      <ErrorLog :errorLog="errorLog" />
    </v-layout>
    <v-container fluidclass="mt-5">
      <v-data-table :mobile-breakpoint="0" :headers="headers" :items="itemsWithSno" class="elevation-1" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
        <template v-slot:[`item.date`]="{ item }"> {{ dateFormat(new Date(parseInt(item.date))) }}</template>
        <template v-slot:[`item.createdAt`]="{ item }"> {{ dateFormat(new Date(parseInt(item.createdAt))) }}</template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row>
            <router-link
              :to="{
                name: 'SetMenuOrderDelivery',
                params: { masterId: item._id },
                query: { masterId: item._id },
              }"
              class="mx-auto"
            >
              View
            </router-link>
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import ErrorLog from "@/delivery/components/ErrorLog.vue";
import moment from "moment";
export default {
  components: { ErrorLog },
  watch: {
    "$route.query.reportId": {
      handler() {
        console.log("this.$route.query.reportId", this.$route.query.reportId);
        this.getSetMenuReportMasterByReportId();
      },
    },
  },

  methods: {
    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getSetMenuReportMasterByReportId() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getSetMenuReportMasterByReportId.graphql"),
          variables: {
            reportId: this.$route.query.reportId,
          },
        })
        .refetch({
          variables: {
            reportId: this.$route.query.reportId,
          },
        })
        .then(data => {
          this.loading = false;
          if (data.data.getSetMenuReportMasterByReportId) {
            this.reportMasters = data.data.getSetMenuReportMasterByReportId.setMenuReportMasters;
            this.errorLog = data.data.getSetMenuReportMasterByReportId.setmenuReport?.errorLog;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data: () => ({
    loading: true,
    btnloading: false,
    reportMasters: [],
    errorLog: null,
    headers: [
      {
        text: "#",
        value: "slNo",
        sortable: false,
        width: 90,
      },
      { text: "Date", value: "date", width: 200, sortable: false },
      { text: "No Of Delivery", value: "noOfDelivery", width: 200, sortable: false },
      { text: "Morning Delivery", value: "morningDelivery", width: 200, sortable: false },
      { text: "Evening Delivery", value: "eveningDelivery", width: 200, sortable: false },
      { text: "Night Delivery", value: "nightDelivery", width: 200, sortable: false },

      {
        text: "Created At",
        value: "createdAt",
        sortable: false,
        width: 120,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: 60,
      },
    ],
  }),
  computed: {
    itemsWithSno() {
      if (this.reportMasters == null) return [];
      return this.reportMasters.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  created() {},
  mounted() {
    this.getSetMenuReportMasterByReportId();
  },
};
</script>
